import { EntitySelectionAggregateResult } from '../../../Selection/Model/EntitySelectionAggregateResult';

export default function getResultCount(result: EntitySelectionAggregateResult)
{
    return result.aggregates[0].toString();
}
